<template>
  <div>
    <b-card header="Office365 Calendar" header-tag="h4" body-class="mb-3 pb-2">
      <div class="row crm-row pt-5 pr-4">
        <div class="col-md-4">
          <ul v-if="calendars.length">
            <li v-for="calendar in calendars" :key="calendar.id">
              <button class="btn btn-light btn-block" type="button" @click="getEventList(calendar.id, calendar.canEdit)" :class="{ active : calendar_id === calendar.id }">
                {{ calendar.name }}
              </button>
            </li>
          </ul>
        </div>
        <div class="col-md-8">
          <FullCalendar ref="calendar" :options="calendarOptions"/>
          <EventModal v-if="showModal" :info="info" :show="showModal" @close="closeEventModal()"/>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import EventModal from './EventModal';

export default {
  name: 'calendar',
  components: {
    FullCalendar,
    EventModal
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: 'dayGridMonth',
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        editable: true,
        events: this.eventsCallback,
        // events: [],
        eventClick: this.eventClick,
        dateClick: this.dateClick,
        eventDrop: this.eventDrop,
      },
      calendars: [],
      events: [],
      calendar_id: null,
      calendarCanEdit: false,
      showModal: false,
      info: {
        event: {},
        calendars: [],
        selectedDate: "",
        calendar_id: null,
      },
      dragEvent: {
        start: {
          dateTime: "",
          timeZone: "Europe/London"
        },
        end: {
          dateTime: "",
          timeZone: "Europe/London"
        },
      }
    }
  },
  mounted() {
    this.get_calendars();
  },
  watch: {
    $route(to, from) {
      if (from.name === "create_calendar_event" && to.name === "calendar") {
        this.$refs.calendar.getApi().refetchEvents();
      }
    }
  },
  methods: {
    dateClick(info) {
      if (this.calendarCanEdit) {
        this.info.calendars = this.calendars.filter(function (elem) { return elem.canEdit;});
        this.info.selectedDate = info.dateStr;
        this.info.event = {};
        this.info.calendar_id = this.calendar_id;
        this.showModal = true;
      }
    },
    eventClick(info) {
      if (this.calendarCanEdit) {
        this.info.event = this.getEventFromId(info.event.id);
        this.info.calendars = this.calendars.filter(function (elem) { return elem.canEdit;});
        this.info.selectedDate = info.dateStr;
        this.info.calendar_id = this.calendar_id;
        this.showModal = true;
      }
    },
    eventDrop(info) {
      this.dragEvent.start.dateTime = this.$moment.utc(new Date(info.event.startStr)).format("YYYY-MM-DD") + "T" +
                                      this.$moment.utc(new Date(info.event.startStr)).format("HH:mm") + ":00.0000000";
      this.dragEvent.end.dateTime = this.$moment.utc(new Date(info.event.endStr)).format("YYYY-MM-DD") + "T" + this.$moment.utc(new Date(info.event.endStr)).format("HH:mm") +
                                    ":00.0000000";
      axios.patch(this.crmApiPath + 'msgraph/calendar/' + this.calendar_id + '/events/' + info.event.id, this.dragEvent).then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
        }
      }).catch(error => console.log(error));

    },
    get_calendars() {
      axios.get(this.crmApiPath + 'msgraph/calendar/calendars ').then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          this.calendars = response.data.calendars.data.value;
          this.getEventList(response.data.calendars.data.value[0].id, response.data.calendars.data.value[0].canEdit);
        }
      }).catch(error => console.log(error));
    },
    popup_window(url, title, w, h) {
      // Fixes dual-screen position                             Most browsers      Firefox
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      const systemZoom = width / window.screen.availWidth;
      const left = (width - w) / 2 / systemZoom + dualScreenLeft;
      const top = (height - h) / 2 / systemZoom + dualScreenTop;
      const newWindow = window.open(url, title,
          `
          scrollbars=yes,
          width=${w / systemZoom},
          height=${h / systemZoom},
          top=${top},
          left=${left}
          `
      );
      if (window.focus) newWindow.focus();
    },
    getEventList(calendar_id, canEdit) {
      this.calendar_id = calendar_id;
      this.calendarCanEdit = canEdit;
      this.$refs.calendar.getApi().refetchEvents();
    },
    handleEvents(events) {

    },
    eventsCallback(info, successCallback, failureCallback) {
      let params = {
        startDateTime: info.startStr,
        endDateTime: info.endStr
      };
      axios.get(this.crmApiPath + 'msgraph/calendar/' + this.calendar_id + '/events', {params}).then(response => {
        let that = this;
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          if ('error' in response.data.events.data) {
            let eventList = [];
            that.events = [];
            successCallback(eventList);
          }
          else {
            let eventList = response.data.events.data.value.map(function (elem) {
              return {
                title: elem.subject,
                start: that.getDate(elem.start.dateTime),
                end: that.getDate(elem.end.dateTime),
                id: elem.id,
              }
            });
            that.events = response.data.events.data.value;
            successCallback(eventList);
          }

        }
      }).catch(error => console.log(error));
    },
    getDate(strDate) {
      let rtDate = new Date(strDate);
      rtDate.setHours(rtDate.getHours());
      return rtDate;
    },
    getEventFromId(id) {
      let arr = this.events.filter(function (element) {
        return element.id === id
      });
      return arr[0];
    },
    closeEventModal() {
      this.showModal = false;
      this.$refs.calendar.getApi().refetchEvents();
    }
  },
}
</script>
<style lang="scss" scoped>
ul {
  list-style:      none;
  display:         flex;
  min-height:      150px;
  flex-direction:  column;
  justify-content: space-between;
}

ul li {
  padding: 10px 0;
}

button.active {
  color:            #212529 !important;
  background-color: #5AB8FF !important;
  border-color:     #5AB8FF !important;
}
</style>
